import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';

@Pipe({
  name: 'highlight',
  standalone: true
})
export class HighlightPipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(text: string | null | undefined, search: string): SafeHtml {
    if (!text || !search) {
      return text ?? '';
    }

    // First, sanitize the input text to remove any HTML tags
    const safeText = this.sanitizer.sanitize(SecurityContext.HTML, text) || '';

    const pattern = search
      .replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') // Escape special characters
      .split(' ')
      .filter(t => t.length > 0)
      .join('|');

    const regex = new RegExp(pattern, 'gi');

    // Now it's safe to add highlight spans
    const result = safeText.replace(regex, match => `<span class="highlight">${match}</span>`);

    // Use sanitize instead of bypass to ensure security
    return this.sanitizer.sanitize(SecurityContext.HTML, result) || '';
  }
}
